module.exports = __webpack_public_path__ + "img/youxia_big@2x.ec4d8f31.png";